import { Component, OnInit } from '@angular/core';
import { AuthService, GoogleLoginProvider } from 'angular-6-social-login';
import { HttpService } from '../../../services/http/http.service';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { MatSnackBar } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin/admin.service';
import { UtilityService } from 'src/app/services/utility/utility.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  // emailArray = ['ashish.vishwakarma@bridgelabz.com', 'nagendra.singh@bridgelabz.com',
  //   // tslint:disable-next-line:max-line-length
  //   'jaspreet.gill@bridgelabz.com', 'sudhakar.naidu@bridgelabz.com', 'testingtestdatablz@gmail.com', 'manoj@bridgelabz.com',
  //   'gunjan.sharma@bridgelabz.com', 'mamta@bridgelabz.com',
  //   'veejay@bridgelabz.com', 'narayan@bridgelabz.com', 'gauri@bridgelabz.com', 'anirudh@bridgelabz.com',
  //   'shweta.bodke@bridgelabz.com', 'aniket.chile@bridgelabz.com', 'varshashobha1996@gmail.com', 'mohitkr1301@gmail.com',
  //   'bandgar09@gmail.com', 'patilrohini43@gmail.com', 'sachinchouksey017@gmail.com', 'ansaruddeen030@gmail.com',
  // 'honeykrsingh16@gmail.com'];

  hide: any;
  flag = false;
//  token1="eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiREVWIiwiZXhwIjoxNTYxMjczNDcwLCJ1c2VySWQiOiIgIn0.nM2JqFILFQWemW08WVrBTURA7xfuBVClBAIOnU7DaXY"

  constructor(private socialAuthService: AuthService,
    private httpService: HttpService,
    private localStorageService: LocalstorageService,
    private snackbar: MatSnackBar,
    private adminService: AdminService,
    private utility: UtilityService) { }

  ngOnInit() {
  }
  // tslint:disable-next-line:member-ordering
  email = new FormControl('', [Validators.required, Validators.email]);
  // tslint:disable-next-line:member-ordering
  password = new FormControl('', [Validators.required]);
  getEmailErrorMessage() {
    return this.email.hasError('required') ? 'Email is a required field' :
      this.email.hasError('email') ? 'Not a valid email' :
        '';
  }

  getPasswordErrorMessage() {
    return this.email.hasError('required') ? 'Password is a required field' :
      '';
  }

  abc(){
    this.flag = true;
  }

  login() {
    // tslint:disable-next-line:prefer-const
    let socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    this.socialAuthService.signIn(socialPlatformProvider).then(
      (userData) => {
        console.log('google sign in data : ', userData);
        // if (this.emailArray.includes(userData.email)) {
          this.utility.showSpinner();
          this.adminService.getToken(userData.email)
            .subscribe(response => {

              if ((response as any).code === '401' ) {
                this.utility.openSnackBar('Unauthorized');
              } else {
                this.localStorageService.setData('email', userData.email);
                this.localStorageService.setData('id', userData.id);
                this.localStorageService.setData('token', (response as any).data);
               // this.localStorageService.setData('token1',this.token1);
                this.localStorageService.setData('name', userData.name);
                this.httpService.redirectTo('admin/campaign');
              }
              this.utility.hideSpinner();
              
            }, (error) => {
              this.utility.hideSpinner();
              // this.utility.openSnackBar(error.)
            });

        // } else {
        //   this.utility.openSnackBar('Not A Valid Admin Login');
        // }
      }
    );
  }
}